var _div;
import { useCallback, useLayoutEffect } from 'react';
import { Alignment, Fit, Layout, useRive } from '@rive-app/react-canvas';
import cn from 'clsx';
import { RIVE_ANIMATED_COIN_URL } from "../shared/constants";
import { isTestingJest } from "../utils/jest";
import { COIN_RIVE_ANIMATION } from "./constants";
import { jsx as _jsx } from "react/jsx-runtime";
export var AnimatedCoinRive = function AnimatedCoinRive(_ref) {
  var startAnimation = _ref.startAnimation,
    className = _ref.className,
    style = _ref.style,
    dataTestId = _ref['data-testid'],
    dataCy = _ref['data-cy'];
  var _useRive = useRive({
      src: RIVE_ANIMATED_COIN_URL,
      autoplay: false,
      layout: new Layout({
        fit: Fit.Contain,
        alignment: Alignment.TopLeft
      }),
      useOffscreenRenderer: true,
      artboard: COIN_RIVE_ANIMATION
    }),
    rive = _useRive.rive,
    RiveComponent = _useRive.RiveComponent;
  var playAnimation = useCallback(function () {
    rive === null || rive === void 0 ? void 0 : rive.play();
  }, [rive]);
  var stopAnimation = useCallback(function () {
    rive === null || rive === void 0 ? void 0 : rive.reset({
      artboard: COIN_RIVE_ANIMATION
    });
  }, [rive]);
  useLayoutEffect(function () {
    if (startAnimation) {
      playAnimation();
    } else {
      stopAnimation();
    }
  }, [startAnimation, playAnimation, stopAnimation]);
  return isTestingJest ? _div || (_div = /*#__PURE__*/_jsx("div", {
    "data-testid": "playroom-animated-coin-rive"
  })) : /*#__PURE__*/_jsx(RiveComponent, {
    style: style,
    className: cn('tw-w-2.4 tw-h-4.8', className),
    "data-testid": dataTestId,
    "data-cy": dataCy,
    onMouseEnter: playAnimation,
    onMouseLeave: stopAnimation
  });
};
export default AnimatedCoinRive;